import io, { Socket } from "socket.io-client";
import { env } from "../.env";
import { useState, useEffect } from "react";
import { logger } from "utils/logger/logger";
import { useMemo } from "react";
const token = localStorage.getItem("token");

export const useSocket = () => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const url: string = env.REACT_APP_SOCKET_URL;

  // const defaultOptions: any = {
  //   path: env.REACT_APP_CLIENT_SOCKET_PATH,
  //   auth: {
  //     token,
  //   },
  // };

  const defaultOptions: any = useMemo(() => {
    return {
      path: env.REACT_APP_CLIENT_SOCKET_PATH,
      auth: {
        token,
      },
    };
  }, [env.REACT_APP_CLIENT_SOCKET_PATH, token]);

  useEffect(() => {
    const newSocket: any = io(url, {
      ...defaultOptions,
    });

    setSocket(newSocket);

    return () => {
      logger.log()("socket closed ", newSocket.id);
      newSocket.close();
    };
  }, [url]);
  // TODO memoize this return value
  return socket;
};

//TODO  remove this commented code

// export let socketJs = io(`${env.REACT_APP_SOCKET_URL}`, {
//   auth: {
//     token,
//   },
//   path: `${env.REACT_APP_CLIENT_SOCKET_PATH}`,
// });
